import { type TransformerConfig } from '../common/types';
import { createDecodeFromDbFn, createEncodeToDbFn } from '../common/utils';
import { createSha256Transformer, createTimestampTransformer } from '../common/sql';
import { CategorisationRunSchema, DBCategorisationRunSchema } from './schemas';

export const CategorisationRunCodecConfig: TransformerConfig<
  typeof CategorisationRunSchema,
  typeof DBCategorisationRunSchema
> = {
  name: 'CategorisationRun',
  clientSchema: CategorisationRunSchema,
  dbSchema: DBCategorisationRunSchema,
  transformers: [
    ...(['configHash', 'scopeHash'] as const).map(field =>
      createSha256Transformer<typeof CategorisationRunSchema, typeof DBCategorisationRunSchema>(
        field
      )
    ),
    ...(['startedAt', 'finishedAt', 'updatedAt'] as const).map(field =>
      createTimestampTransformer<typeof CategorisationRunSchema, typeof DBCategorisationRunSchema>(
        field,
        { nullable: true }
      )
    ),
    createTimestampTransformer<typeof CategorisationRunSchema, typeof DBCategorisationRunSchema>(
      'createdAt'
    ),
  ],
};

export const encodeCategorisationRunToDb = createEncodeToDbFn(CategorisationRunCodecConfig);
export const decodeCategorisationRunFromDb = createDecodeFromDbFn(CategorisationRunCodecConfig);
